import { render, staticRenderFns } from "./Ide.vue?vue&type=template&id=6eb3053b&"
import script from "./Ide.vue?vue&type=script&lang=js&"
export * from "./Ide.vue?vue&type=script&lang=js&"
import style0 from "./Ide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports